export default __webpack_public_path__ + "static/media/469.048f682f.jpg";